import { render, staticRenderFns } from "./DispatchLetter.vue?vue&type=template&id=0daaa88a&scoped=true"
import script from "./DispatchLetter.vue?vue&type=script&lang=js"
export * from "./DispatchLetter.vue?vue&type=script&lang=js"
import style0 from "./DispatchLetter.vue?vue&type=style&index=0&id=0daaa88a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daaa88a",
  null
  
)

export default component.exports